import axios from '@/http/axios/index.js'


export default {
    getNotifications(payload) {
        return axios.get('rps/notifications', { params: payload }).then(res => res.data)
    }
}